import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { QualificationDTO } from '@dto/doctor/QualificationDTO';
import { StateUtil } from '@util/StateUtil';
import { ViewUtil } from '@util/ViewUtil';
import { DictionaryModel } from '@model/DictionaryModel';
import { ApplicationModel } from '@model/ApplicationModel';
import { State } from '@common/State';
import { QualificationListDTO } from '@dto/doctor/QualificationsListDTO';
import * as _ from 'lodash';
import { plainToClass } from 'class-transformer';
import { DoctorService } from '@service/DoctorService';
import { Transition } from '@uirouter/core';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-doctor-qualification-edit',
  templateUrl: './DoctorQualificationEditComponent.html',
  styleUrls: [ './DoctorQualificationEditComponent.scss' ]
})
export class DoctorQualificationEditComponent implements OnInit {
  public availableQualifications$: Observable<QualificationDTO[]>;

  public id: number = this.transition.params().doctorId;

  public qualifications: QualificationDTO[];

  public newQualification: QualificationDTO;

  public disabledSubmit: boolean = false;

  constructor(private stateUtil: StateUtil,
              private viewUtil: ViewUtil,
              private fb: FormBuilder,
              private dictionaryModel: DictionaryModel,
              private applicationModel: ApplicationModel,
              private transition: Transition,
              private doctorService: DoctorService) {
    this.applicationModel.selectSideBarItemWithState(State.MAIN.DOCTOR.LIST);
  }

  public ngOnInit(): void {
    this.doctorService.getQualifications(this.id).toPromise()
      .then((data: QualificationListDTO) => {
        this.qualifications = data.qualifications;

        this.setAvailableQualifications();
      });
  }

  public remove(index: number): void {
    this.qualifications.splice(index, 1);

    this.setAvailableQualifications();
  }

  public addNewQualification(): void {
    this.qualifications.push(this.newQualification);
    this.newQualification = null;

    this.setAvailableQualifications();
  }

  public onSelectedChanged(): void {
    this.setAvailableQualifications();
  }

  public save(): void {
    const qualifications = _.uniqBy(this.qualifications, 'id');

    this.disabledSubmit = true;

    this.doctorService.updateQualifications(this.id, plainToClass(QualificationListDTO, { qualifications }))
      .toPromise()
      .then(() => {
        this.viewUtil.showToastSuccess('VIEW.MAIN.DOCTOR.QUALIFICATIONS.MESSAGE.UPDATE_SUCCESS');
        this.goBack();
      })
      .catch((error) => {
        this.viewUtil.handleServerError(error);
      })
      .finally(() => {
        this.disabledSubmit = false;
      });
  }

  public goBack(): void {
    history.back();
  }

  private setAvailableQualifications(): void {
    const selectedQualificationIds = this.qualifications.map(q => q.id);
    this.availableQualifications$ = this.dictionaryModel.qualifications$
      .pipe(
        map((qualifications: QualificationDTO[]) => qualifications
          .filter((qualification: QualificationDTO) => !selectedQualificationIds.includes(qualification.id)))
      );
  }
}
